var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.246,
    height: 38.307,
    viewBox: "0 0 31.246 38.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1442",
    "data-name": "Tracciato 1442",
    d: "M28.661,1.589a1.5,1.5,0,1,0-2.122,2.122l2.734,2.734H13.061c-1.429,0-2.593,0-3.537.077a6.96,6.96,0,0,0-2.663.664,6.8,6.8,0,0,0-2.97,2.97,6.96,6.96,0,0,0-.664,2.663c-.077.944-.077,2.108-.077,3.537v2.182a1.5,1.5,0,0,0,3,0V16.42c0-1.508,0-2.548.067-3.356a4.058,4.058,0,0,1,.347-1.544A3.8,3.8,0,0,1,8.223,9.861a4.058,4.058,0,0,1,1.544-.347c.808-.066,1.848-.067,3.356-.067H29.273l-2.734,2.734A1.5,1.5,0,0,0,28.661,14.3l5.3-5.3a1.5,1.5,0,0,0,0-2.122ZM34.4,22.069a1.5,1.5,0,1,0-3,0v2.118c0,1.508,0,2.548-.067,3.356a4.061,4.061,0,0,1-.347,1.544,3.8,3.8,0,0,1-1.659,1.659,4.058,4.058,0,0,1-1.544.346c-.808.066-1.848.067-3.356.067H8.273l2.734-2.734A1.5,1.5,0,1,0,8.885,26.3l-5.3,5.3a1.5,1.5,0,0,0,0,2.122l5.3,5.3A1.5,1.5,0,0,0,11.007,36.9L8.273,34.161H24.485c1.429,0,2.593,0,3.537-.077a6.961,6.961,0,0,0,2.663-.664,6.8,6.8,0,0,0,2.97-2.97,6.959,6.959,0,0,0,.664-2.663c.077-.944.077-2.108.077-3.537V22.069Z",
    transform: "translate(-3.15 -1.15)",
    fill: "#13bf95",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslator);
export default __webpack_public_path__ + "static/media/translator.979396506055be30c2809cdb20a1fa77.svg";
export { ForwardRef as ReactComponent };